<template>
  <Modal v-bind="$attrs" @cancel="$emit('cancel')" @open="onModalOpen" @confirm="onConfirm">
    <div class="query-form">
      <el-input v-model="queryString" clearable placeholder="请输入试玩名称"></el-input>
      <el-button class="query-btn" type="primary" @click="queryAction" :loading="queryLoading">查询</el-button>
    </div>
    <el-table v-loading="queryLoading" :data="tableData" height="180" class="common-el-table-styles" border style="width: 100%">
      <el-table-column width="210" label="试玩页名称" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-radio class="profile-radio" v-model="pathValue" :label="row.playable_page_path">&ensp; </el-radio>
          <span class="profile-name" @click="pathValue = row.playable_page_path">{{ row.playable_page_name }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="playable_page_path" label="试玩ID" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="status_text" width="70" label="试玩状态"> </el-table-column>
      <el-table-column prop="nick_name" width="120" label="试玩别名" show-overflow-tooltip> </el-table-column>
    </el-table>
    <p v-if="msg" style="color: red; font-size: 12px">{{ msg }}</p>
  </Modal>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Modal from './modal.vue'
import { getWxGamePlayablePage } from '@/api/tencent.local.model'

// eslint-disable-next-line
const props = defineProps({
  currentRow: {
    type: Object
  }
})

// eslint-disable-next-line
const emits = defineEmits(['confirm', 'cancel'])

const tableData = ref([])
const pathValue = ref('')
const queryString = ref('')
const queryLoading = ref(false)
const msg = ref('')

const queryAction = () => {
  const { ad_account_id, plan } = props.currentRow
  const { promoted_object_id } = plan.promotedObject || {}
  if (promoted_object_id) {
    queryLoading.value = true
    getWxGamePlayablePage({ play_name: queryString.value, ad_account_id, appId: promoted_object_id })
      .then((data) => {
        tableData.value = data.map((row) => {
          return {
            ...row,
            status_text: row.status === 'PLAYABLE_PAGE_STATUS_ONLINE' ? '版本在线' : '版本下线'
          }
        })
      })
      .finally(() => {
        queryLoading.value = false
      })
  }
}
const onModalOpen = () => {
  queryAction()
}

const onConfirm = () => {
  if (!pathValue.value) {
    return (msg.value = '请选择试玩页')
  }
  const selectedRow = tableData.value.find((row) => {
    return row.playable_page_path === pathValue.value
  })

  emits('confirm', selectedRow)
  pathValue.value = ''
  queryString.value = ''
  msg.value = ''
}
</script>

<style lang="scss" scoped>
.query-form {
  display: flex;
  margin-bottom: 10px;
  .query-btn {
    margin-left: 10px;
  }
}

::v-deep .profile-radio {
  margin-right: 0;
}
.profile-name {
  cursor: pointer;
}
</style>
